/* PS AFEX S2 — Photo-to-Recipe game + feature cards */
(function () {
  if (window.__PS_AFEX_S2__) return;
  window.__PS_AFEX_S2__ = true;

  function playTick(a, b, c, d) {
    if (window.PS_AFEX && window.PS_AFEX.playTick) window.PS_AFEX.playTick(a, b, c, d);
  }

  function init() {
    var root = document.getElementById('ps-afex-aicook');
    if (!root) return;

    var dataEl = document.getElementById('ps-afex-ingredients-data');
    var ingredientsData = [];
    try {
      ingredientsData = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (e) {
      ingredientsData = [];
    }
    if (!ingredientsData.length) return;

    var ingField = document.getElementById('ps-afex-ingField');
    var phoneScreen = document.getElementById('ps-afex-phoneScreen');
    var flashOverlay = document.getElementById('ps-afex-flashOverlay');
    var scanLine = document.getElementById('ps-afex-scanLine');
    var phoneIdle = document.getElementById('ps-afex-phoneIdle');
    var phoneCapture = document.getElementById('ps-afex-phoneCapture');
    var phoneScanning = document.getElementById('ps-afex-phoneScanning');
    var phoneResult = document.getElementById('ps-afex-phoneResult');
    var capturedEmoji = document.getElementById('ps-afex-capturedEmoji');
    var scanThumb = document.getElementById('ps-afex-scanThumb');
    var resultThumb = document.getElementById('ps-afex-resultThumb');
    var resultName = document.getElementById('ps-afex-resultName');
    var resultMode = document.getElementById('ps-afex-resultMode');
    var recipeCardReveal = document.getElementById('ps-afex-recipeCardReveal');
    var rcEmoji = document.getElementById('ps-afex-rcEmoji');
    var rcName = document.getElementById('ps-afex-rcName');
    var rcMode = document.getElementById('ps-afex-rcMode');
    var rcTemp = document.getElementById('ps-afex-rcTemp');
    var rcTime = document.getElementById('ps-afex-rcTime');
    var resetGameBtn = document.getElementById('ps-afex-resetGameBtn');
    var phoneSent = document.getElementById('ps-afex-phoneSent');
    var sendToFryerBtn = document.getElementById('ps-afex-sendToFryerBtn');
    var fryerDial = document.getElementById('ps-afex-fryerDial');
    var fryerDialRing = document.getElementById('ps-afex-fryerDialRing');
    var fryerMin = document.getElementById('ps-afex-fryerMin');
    var fryerSec = document.getElementById('ps-afex-fryerSec');
    var fryerEmpty = document.getElementById('ps-afex-fryerEmpty');
    var fryerDish = document.getElementById('ps-afex-fryerDish');
    var fryerDishRight = document.getElementById('ps-afex-fryerDishRight');
    var fryerWindow = document.getElementById('ps-afex-fryerWindow');
    var fryerSteam = document.getElementById('ps-afex-fryerSteam');
    var fryerCaption = document.getElementById('ps-afex-fryerCaption');
    var phoneCol = root.querySelector('.phone-col');
    var phoneMock = root.querySelector('.phone-mock');
    var fryerMock = root.querySelector('.air-fryer-mock');
    var gameStage = document.getElementById('ps-afex-gameStage');

    function smoothPanTo(el, opts) {
      if (!el) return;
      opts = opts || {};
      var delay = opts.delay || 0;
      var block = opts.block || 'center';
      var run = function () {
        try {
          el.scrollIntoView({ behavior: 'smooth', block: block, inline: 'nearest' });
        } catch (e) {
          el.scrollIntoView(true);
        }
      };
      if (delay) setTimeout(run, delay);
      else requestAnimationFrame(run);
    }

    function populateRecipeCard(data) {
      if (!data || !rcEmoji) return;
      rcEmoji.className = 'rc-emoji ing-tile ing-tile-lg' + (data.image ? ' has-image' : '');
      rcEmoji.style.background = data.image ? '' : tileBg(data.c1, data.c2);
      if (data.image) {
        rcEmoji.innerHTML = ingredientImageHtml(data);
      } else {
        rcEmoji.textContent = data.emoji || '';
      }
      if (rcName) rcName.textContent = data.recipe;
      if (rcMode) rcMode.textContent = 'Texture: ' + data.mode;
      if (rcTemp) rcTemp.textContent = data.temp;
      if (rcTime) rcTime.textContent = data.time;
    }

    function revealRecipeCard(data) {
      populateRecipeCard(data);
      if (!recipeCardReveal) return;
      recipeCardReveal.classList.add('show');
      smoothPanTo(recipeCardReveal, { delay: 400, block: 'center' });
    }

    function tileBg(c1, c2) {
      return 'radial-gradient(circle at 35% 28%, ' + c1 + ', ' + c2 + ' 78%)';
    }

    function tileInnerHtml(data, sizeClass) {
      var classes = 'ing-tile' + (sizeClass ? ' ' + sizeClass : '');
      if (data.image) classes += ' has-image';
      var style = data.image ? '' : ('background:' + tileBg(data.c1, data.c2));
      var content = data.image
        ? '<img src="' + data.image + '" alt="' + (data.name || '').replace(/"/g, '&quot;') + '" loading="lazy" decoding="async">'
        : (data.emoji || '');
      return '<div class="' + classes + '" style="' + style + '">' + content + '</div>';
    }

    function ingredientImageHtml(data) {
      if (data.image) {
        return '<img src="' + data.image + '" alt="' + (data.name || '').replace(/"/g, '&quot;') + '" loading="lazy" decoding="async">';
      }
      return data.emoji || '';
    }

    function setPhoneThumb(el, data) {
      if (!el) return;
      el.className = 'phone-ing-thumb ing-tile ing-tile-lg' + (data.image ? ' has-image' : '');
      el.style.background = data.image ? '' : tileBg(data.c1, data.c2);
      if (data.image) {
        el.innerHTML = ingredientImageHtml(data);
      } else {
        el.textContent = data.emoji || '';
      }
    }

    function dismissFlyingItem(el) {
      if (!el) return;
      el.classList.remove('flying');
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
      el.style.visibility = 'hidden';
    }

    function setFryerDishEl(el, data, state) {
      if (!el) return;
      el.classList.remove('cooking', 'done');
      if (!data || !state) {
        el.innerHTML = '';
        el.setAttribute('aria-hidden', 'true');
        return;
      }
      el.innerHTML = ingredientImageHtml(data);
      el.classList.add(state);
      el.setAttribute('aria-hidden', 'false');
    }

    function showFryerDish(data, state) {
      setFryerDishEl(fryerDish, data, state);
      setFryerDishEl(fryerDishRight, data, state);
      if (fryerWindow) {
        fryerWindow.classList.remove('is-cooking', 'is-done');
        if (state === 'cooking') fryerWindow.classList.add('is-cooking');
        if (state === 'done') fryerWindow.classList.add('is-done');
      }
    }

    var gameBusy = false;
    var fryerCooking = false;
    var currentRecipe = null;
    var countdownIntervalRef = null;

    function createSteamParticles() {
      if (!fryerSteam || fryerSteam.childElementCount) return;
      for (var i = 0; i < 10; i++) {
        var p = document.createElement('div');
        p.className = 'steam-particle';
        p.style.left = (10 + Math.random() * 80) + '%';
        p.style.animationDelay = (Math.random() * 2) + 's';
        p.style.animationDuration = (1.8 + Math.random() * 1.2) + 's';
        fryerSteam.appendChild(p);
      }
    }
    createSteamParticles();

    var slotAngles = [-100, -55, -15, 25, 65, 105, 150, -140];
    function isMobileLayout() {
      return window.matchMedia('(max-width: 760px)').matches;
    }
    function layoutIngredients() {
      if (!ingField || !phoneCol) return;
      var mobile = isMobileLayout();
      ingField.classList.toggle('is-mobile-tray', mobile);
      ingField.innerHTML = '';

      if (mobile) {
        ingredientsData.forEach(function (data, i) {
          var el = document.createElement('div');
          el.className = 'ing-item';
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
          el.setAttribute('aria-label', 'Capture ' + (data.name || 'ingredient'));
          el.innerHTML = tileInnerHtml(data) + '<div class="ring"></div>';
          el.style.animationDelay = (Math.random() * 2) + 's';
          el.style.animationDuration = (3 + Math.random() * 1.6) + 's';
          el.dataset.index = i;
          el.addEventListener('click', function () { captureIngredient(el, data); });
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              captureIngredient(el, data);
            }
          });
          ingField.appendChild(el);
        });
        return;
      }

      var stageRect = { width: ingField.offsetWidth, height: ingField.offsetHeight };
      var cx = stageRect.width / 2;
      var cy = stageRect.height / 2;
      var rx = Math.min(260, stageRect.width / 2 - 8);
      var ry = Math.min(200, stageRect.height / 2 - 12);
      ingredientsData.forEach(function (data, i) {
        var angle = (slotAngles[i % slotAngles.length]) * Math.PI / 180;
        var x = cx + Math.cos(angle) * rx;
        var y = cy + Math.sin(angle) * ry;
        var el = document.createElement('div');
        el.className = 'ing-item';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', 'Capture ' + (data.name || 'ingredient'));
        el.innerHTML = tileInnerHtml(data) + '<div class="ring"></div>';
        el.style.left = x + 'px';
        el.style.top = y + 'px';
        el.style.animationDelay = (Math.random() * 3) + 's';
        el.style.animationDuration = (3.4 + Math.random() * 2) + 's';
        el.dataset.index = i;
        el.addEventListener('click', function () { captureIngredient(el, data); });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            captureIngredient(el, data);
          }
        });
        ingField.appendChild(el);
      });
    }
    layoutIngredients();
    window.addEventListener('resize', function () { if (!gameBusy) layoutIngredients(); });

    function showPhoneState(state) {
      [phoneIdle, phoneCapture, phoneScanning, phoneResult, phoneSent].forEach(function (el) {
        if (el) el.style.display = 'none';
      });
      if (state) state.style.display = 'flex';
    }

    function captureIngredient(el, data) {
      if (gameBusy) return;
      gameBusy = true;
      playTick(700, 0.08, 'square', 0.05);

      var startRect = el.getBoundingClientRect();
      var targetRect = phoneScreen.getBoundingClientRect();
      var targetX = targetRect.left + targetRect.width / 2 - startRect.width / 2;
      var targetY = targetRect.top + targetRect.height / 2 - startRect.height / 2;

      ingField.classList.add('captured-mode');
      smoothPanTo(phoneMock || phoneCol, { delay: 80, block: 'center' });
      el.classList.add('flying');
      el.style.left = startRect.left + 'px';
      el.style.top = startRect.top + 'px';
      el.style.margin = '0';
      requestAnimationFrame(function () {
        el.style.transform = 'translate(' + (targetX - startRect.left) + 'px, ' + (targetY - startRect.top) + 'px) scale(0.6)';
      });

      setTimeout(function () {
        flashOverlay.classList.remove('flash');
        void flashOverlay.offsetWidth;
        flashOverlay.classList.add('flash');
        playTick(1000, 0.06, 'sine', 0.04);
        capturedEmoji.className = 'captured-emoji ing-tile ing-tile-lg' + (data.image ? ' has-image' : '');
        capturedEmoji.style.background = data.image ? '' : tileBg(data.c1, data.c2);
        if (data.image) {
          capturedEmoji.innerHTML = ingredientImageHtml(data);
        } else {
          capturedEmoji.textContent = data.emoji;
        }
        dismissFlyingItem(el);
        showPhoneState(phoneCapture);

        setTimeout(function () {
          setPhoneThumb(scanThumb, data);
          showPhoneState(phoneScanning);
          scanLine.classList.add('active');
          playTick(220, 0.4, 'sawtooth', 0.02);

          setTimeout(function () {
            scanLine.classList.remove('active');
            resultName.textContent = data.recipe;
            resultMode.textContent = data.mode + ' Mode';
            setPhoneThumb(resultThumb, data);
            showPhoneState(phoneResult);
            playTick(660, 0.1, 'triangle', 0.06);

            currentRecipe = data;
            sendToFryerBtn.disabled = false;
            gameBusy = false;
          }, 850);
        }, 350);
      }, 420);
    }

    function sendToFryer() {
      if (!currentRecipe || fryerCooking) return;
      fryerCooking = true;
      sendToFryerBtn.disabled = true;
      playTick(500, 0.08, 'sine', 0.05);
      smoothPanTo(fryerMock, { delay: 120, block: 'center' });

      var startRect = phoneScreen.getBoundingClientRect();
      var endRect = fryerDial.getBoundingClientRect();
      var packet = document.createElement('div');
      var packetImage = currentRecipe.image;
      packet.className = 'transfer-packet' + (packetImage ? ' has-image' : '');
      if (packetImage) {
        packet.innerHTML = '<img src="' + packetImage + '" alt="">';
      } else {
        packet.textContent = currentRecipe.emoji;
      }
      document.body.appendChild(packet);
      var startX = startRect.left + startRect.width / 2 - 17;
      var startY = startRect.top + startRect.height / 2 - 17;
      packet.style.left = startX + 'px';
      packet.style.top = startY + 'px';
      requestAnimationFrame(function () {
        var endX = endRect.left + endRect.width / 2 - 17;
        var endY = endRect.top + endRect.height / 2 - 17;
        packet.style.transform = 'translate(' + (endX - startX) + 'px, ' + (endY - startY) + 'px) scale(0.5)';
        packet.style.opacity = '0.15';
      });

      showPhoneState(phoneSent);
      fryerCaption.textContent = 'Sending recipe to air fryer…';

      setTimeout(function () {
        packet.remove();
        startCooking(currentRecipe);
      }, 450);
    }
    if (sendToFryerBtn) sendToFryerBtn.addEventListener('click', sendToFryer);

    function startCooking(data) {
      fryerCaption.textContent = 'Received: ' + data.recipe;
      fryerDial.classList.add('active');
      fryerDialRing.classList.add('spin');
      playTick(880, 0.1, 'triangle', 0.05);

      setTimeout(function () {
        fryerCaption.textContent = 'Air frying ' + data.recipe + ' at ' + data.temp + ' · ' + data.mode + ' mode…';
        fryerEmpty.style.display = 'none';
        showFryerDish(data, 'cooking');
        fryerSteam.classList.add('active');
        animateCountdown(data.time);
      }, 500);
    }

    function animateCountdown(timeStr) {
      var mins = parseInt(timeStr, 10) || 10;
      var totalSeconds = mins * 60;
      /* Compressed demo timeline — kept short so visitors don't scroll past
         mid-animation. Longer recipes still finish a touch slower than short
         ones, but the whole countdown now stays under ~3.2s of real time. */
      var totalMs = Math.min(3200, Math.max(1800, mins * 180));
      var steps = Math.max(14, Math.round(mins * 1.6));
      var stepMs = totalMs / steps;
      var i = 0;
      clearInterval(countdownIntervalRef);
      /* Show the full programmed time immediately, then tick down */
      fryerMin.textContent = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      fryerSec.textContent = String(totalSeconds % 60).padStart(2, '0');
      countdownIntervalRef = setInterval(function () {
        i++;
        var remain = Math.max(0, Math.round(totalSeconds * (1 - i / steps)));
        var mm = String(Math.floor(remain / 60)).padStart(2, '0');
        var ss = String(remain % 60).padStart(2, '0');
        fryerMin.textContent = mm;
        fryerSec.textContent = ss;
        if (i >= steps) {
          clearInterval(countdownIntervalRef);
          finishCooking();
        }
      }, stepMs);
    }

    function finishCooking() {
      fryerMin.textContent = '00';
      fryerSec.textContent = '00';
      var recipe = (currentRecipe && currentRecipe.recipe) || '';
      var personalTpl = root.getAttribute('data-fryer-done-personal');
      var fallbackTpl = root.getAttribute('data-fryer-done-fallback') || '{recipe} is ready — golden and crisp.';
      var name = window.PS_AFEX && window.PS_AFEX.userName;
      var valid = window.PS_AFEX && window.PS_AFEX.hasValidName
        ? window.PS_AFEX.hasValidName(name)
        : !!(name && name !== 'Guest');
      var tpl = (valid && personalTpl) ? personalTpl : fallbackTpl;
      if (window.PS_AFEX && window.PS_AFEX.formatPersonal) {
        fryerCaption.textContent = window.PS_AFEX.formatPersonal(tpl, { name: name || '', recipe: recipe });
      } else {
        fryerCaption.textContent = recipe + ' is ready — golden and crisp.';
      }
      if (fryerDish) {
        fryerDish.classList.remove('cooking');
        fryerDish.classList.add('done');
      }
      if (fryerDishRight) {
        fryerDishRight.classList.remove('cooking');
        fryerDishRight.classList.add('done');
      }
      if (fryerWindow) {
        fryerWindow.classList.remove('is-cooking');
        fryerWindow.classList.add('is-done');
      }
      fryerSteam.classList.remove('active');
      fryerDialRing.classList.remove('spin');
      playTick(760, 0.15, 'triangle', 0.07);
      setTimeout(function () { playTick(1000, 0.12, 'sine', 0.06); }, 120);
      if (currentRecipe) revealRecipeCard(currentRecipe);
      fryerCooking = false;
    }

    function resetGame() {
      playTick(340, 0.08, 'sine', 0.04);
      recipeCardReveal.classList.remove('show');
      if (rcEmoji) {
        rcEmoji.innerHTML = '';
        rcEmoji.className = 'rc-emoji';
        rcEmoji.removeAttribute('style');
      }
      if (rcName) rcName.textContent = '';
      if (rcMode) rcMode.textContent = '';
      if (rcTemp) rcTemp.textContent = '';
      if (rcTime) rcTime.textContent = '';
      showPhoneState(phoneIdle);
      ingField.classList.remove('captured-mode');
      if (scanThumb) { scanThumb.innerHTML = ''; scanThumb.className = 'phone-ing-thumb'; }
      if (resultThumb) { resultThumb.innerHTML = ''; resultThumb.className = 'phone-ing-thumb'; }
      layoutIngredients();

      currentRecipe = null;
      fryerCooking = false;
      clearInterval(countdownIntervalRef);
      sendToFryerBtn.disabled = false;
      fryerDial.classList.remove('active');
      fryerDialRing.classList.remove('spin');
      fryerMin.textContent = '--';
      fryerSec.textContent = '--';
      fryerCaption.textContent = 'Waiting for a recipe…';
      showFryerDish(null, null);
      fryerSteam.classList.remove('active');
      fryerEmpty.style.display = 'block';
      smoothPanTo(gameStage || ingField, { delay: 350, block: 'center' });
    }
    if (resetGameBtn) resetGameBtn.addEventListener('click', resetGame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
